import { type JSX, Show } from 'solid-js';
import { arrow, signed, type Tone } from '../lib/radar-trends';

// One signed change on the platform radar (#6715) — the card footer, the chart
// panel's head and its tooltip all print it the same way: an arrow, then the sign
// and the number, in the tone's text hue. The arrow is decorative (the sign says
// the direction), so a reader hears "+3", not "black up-pointing triangle".

const TONE_CLASS: Readonly<Record<Tone, string>> = {
  good: 'admin-trend__delta admin-trend__delta--good',
  bad: 'admin-trend__delta admin-trend__delta--bad',
  flat: 'admin-trend__delta admin-trend__delta--flat',
};

export function AdminTrendDelta(props: { delta: number; tone: Tone }): JSX.Element {
  return (
    <span class={TONE_CLASS[props.tone]}>
      <Show when={arrow(props.delta)}>
        {(a) => (
          <span class="admin-trend__arrow" aria-hidden="true">
            {a()}
          </span>
        )}
      </Show>
      {signed(props.delta)}
    </span>
  );
}
